import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import $ from 'jquery';
import styles from './styles.scss';

const initialState = {
  fullName: '',
  projectName: '',
  email: '',
  businessName: '',
  websiteURL: '',
  description: '',
  sending: false
};

class Form extends Component {
  state = {
    ...initialState
  };

  render() {
    const {
      fullName,
      projectName,
      email,
      businessName,
      websiteURL,
      description,
      sending
    } = this.state;

    const product = this.props.location.query && this.props.location.query.product && (
      <h3 className="ls1 mb20">
        Hey! You've selected <span className={`${styles.purple} bold`}>{this.props.location.query.product}.</span>
      </h3>
    );

    return (
      <DocumentTitle title='DesignCue - Get Started'>
        <div className={styles.contactForm}>
          <div className="container-fluid main-container">
            <div className="col-md-10 col-md-offset-1 col-sm-12 mt50">
              <h1 className="text-center h1 mb50">
                Tell us about your design project
              </h1>
              <div className={styles.subHeading}>
                {product}
                <h3 className="ls1 mb20">
                  Give us a brief and one of our project managers will reach out to you.
                </h3>
                <h3 className="ls1 mb100 bold">
                  You’ll be invoiced at a later date.
                </h3>
              </div>
              <div className="row">
                <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                  <form onSubmit={this.onSubmitForm}>
                    <div className="form-group">
                      <label className="bold" htmlFor="fullName">YOUR NAME</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="fullName"
                        placeholder="Enter full name"
                        name="fullName"
                        value={fullName}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="projectName">PROJECT NAME</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="projectName"
                        placeholder="What is your project name?"
                        name="projectName"
                        value={projectName}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="email">YOUR EMAIL</label>
                      <input
                        type="email"
                        className="form-control input-lg"
                        id="email"
                        placeholder="Enter your Email"
                        name="email"
                        value={email}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="businessName">BUSINESS NAME</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="businessName"
                        placeholder="Enter your Business name"
                        name="businessName"
                        value={businessName}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="websiteURL">CURRENT WEBSITE</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="websiteURL"
                        placeholder="Your web URL"
                        name="websiteURL"
                        value={websiteURL}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="description">SHORT BRIEF</label>
                      <textarea
                        className="form-control input-lg"
                        rows="3"
                        id="description"
                        placeholder="Cast your vision"
                        name="description"
                        value={description}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="row">
                      <div className="col-xs-12 text-right mb100">
                        <button className="btn btn-dc-primary bt-xs-block inverse" disabled={sending} type="submit">SUBMIT BRIEF</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }

  onChangeField = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  onSubmitForm = (event) => {
    event.preventDefault();
    this.setState({
      sending: true
    }, this.sendFormData);
  }

  sendFormData = () => {
    const formData = {
      "product_type": this.props.location.query && this.props.location.query.product,
      "full_name": this.state.fullName,
      "project_name": this.state.projectName,
      "email": this.state.email,
      "business_name": this.state.businessName,
      "website_url": this.state.websiteURL,
      "description": this.state.description,
      "design_type": this.props.activeLink,
      "total_cost": this.props.totalCost,
      "up_front_cost": this.props.upFrontCost,
      "turn_around_days": this.props.turnAround,
      "number_of_pages": this.props.pages,
      "wants_symbol_logo": this.props.symbolLogo,
      "wants_type_logo": this.props.typeLogo,
      "wants_color_palette": this.props.colorPalette,
      "wants_type_guide": this.props.typeGuide,
      "wants_illustrations_and_icons": this.props.icons,
      "wants_mobile_views": this.props.mobileViews,
      "wants_animations": this.props.animations,
      "wants_ecommerce": this.props.ecommerce,
      "wants_working_prototype": this.props.prototype,
      "wants_development": this.props.development
    };

    $.ajax({
      url: 'https://formspree.io/pa@designcue.co',
      method: 'POST',
      dataType: 'json',
      data: {
        ...formData
      },
      success: function(res) {
        this.setState({ ...initialState }, this.props.submitSuccess('project'));
      }.bind(this),
      error: function(xhr, status, err) {
        console.error(status, err.toString());
      }
    });
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/pages/GetStarted/index.js